import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { invalidateUserLevAdminGroups } from './useGetUserLevAdminGroups';

export interface IRemoveUserFromLevAdminGroupRequest {
	userId: string;
	groupName: string;
}

export function useRemoveUserFromLevAdminGroupMutation() {
	const userSession = useAdminUserSession();

	return useMutation({
		mutationFn: async (request: IRemoveUserFromLevAdminGroupRequest) => {
			return userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `admin/userOperations/${request.userId}/levAdminGroups/${request.groupName}`,
				}),
				'DELETE'
			);
		},
		onSuccess: (_, variables) => {
			invalidateUserLevAdminGroups(variables.userId);
		},
	});
}
